import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectExperimentsReady } from "./useExperiment";
import { getExperimentVariant } from "../../shared/utilities/amplitudeExperiment";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";

// Legacy visitors must not be exposed to the brand-refresh-only experiment.
const useProminentNavigation = () => {
  const isReady = useSelector(selectExperimentsReady);
  const brandRefresh = isBrandRefreshEnabled();
  return useMemo(
    () => brandRefresh && getExperimentVariant("enterAddressUi") === "prominent-nav",
    [brandRefresh, isReady],
  );
};

export default useProminentNavigation;
